<template>
  <v-container fluid class="pa-4">
    <v-row class="center-container">
      <v-col cols="12" md="6" class="d-flex justify-center align-center">
        <div class="text-center pa-6">
          <v-icon
            icon="mdi-gift-outline"
            size="140"
            color="primary"
          ></v-icon>

          <h1 class="brand-title text-h2 text-md-h1 mb-2" color="secondary">inBook</h1>

          <h2 class="brand-title text-h6 text-md-h5 font-weight-medium text-primary mb-3">
            TUS LISTAS DE REGALOS
          </h2>

          <p class="text-body-1 text-medium-emphasis">
            Crea y comparte tus listas con aquellos que más te quieren
          </p>
        </div>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="pa-6" elevation="2">
          <h2 class="mb-6 text-center">Acceder a una lista</h2>

          <v-form @submit.prevent="accessList">
            <v-text-field
              v-model="listId"
              label="Código de la lista"
              prepend-inner-icon="mdi-identifier"
              variant="outlined"
              required
              hint="Ej: NeSriMSVq_"
              persistent-hint
              class="mb-4"
            ></v-text-field>

            <!-- Modo administrador -->
            <v-expand-transition>
              <div v-if="isAdminMode">
                <v-text-field
                  v-model="adminEmail"
                  label="Email del administrador"
                  prepend-inner-icon="mdi-email"
                  variant="outlined"
                  type="email"
                  required
                  class="mb-4"
                  hint="Introduce el email con el que creaste la lista"
                  persistent-hint
                ></v-text-field>
              </div>
            </v-expand-transition>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              :disabled="!listId || (isAdminMode && !adminEmail)"
            >
              <v-icon start>{{
                isAdminMode ? "mdi-shield-account" : "mdi-magnify"
              }}</v-icon>
              {{ isAdminMode ? "Acceder como administrador" : "Ver lista" }}
            </v-btn>

            <v-divider class="my-4"></v-divider>

            <v-btn variant="text" block @click="toggleAdminMode" class="mb-2">
              {{
                isAdminMode
                  ? "Volver a modo visitante"
                  : "Soy el administrador de esta lista"
              }}
            </v-btn>

            <v-btn
              color="success"
              variant="outlined"
              size="large"
              block
              @click="$router.push('/newlist')"
            >
              <v-icon start>mdi-plus-circle</v-icon>
              Crear nueva lista
            </v-btn>

            <v-btn variant="text" block class="mt-2" @click="showHelp = true">
              ¿Cómo obtengo el código?
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de ayuda -->
    <v-dialog v-model="showHelp" max-width="500">
      <v-card>
        <v-card-title class="pa-4">¿Cómo obtengo el código?</v-card-title>
        <v-card-text class="pa-4">
          <p>
            El código de la lista suele venir en el enlace que te compartieron.
          </p>
          <p class="mb-4">
            Por ejemplo: <code>inbook.es/<strong>NeSriMSVq_</strong></code>
          </p>
          <p>
            El código es la parte final del enlace (en este caso:
            <strong>NeSriMSVq_</strong>)
          </p>
          <p class="mt-4">
            Si no tienes el enlace, contacta con la persona que creó la lista
            para que te lo envíe de nuevo.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showHelp = false">Entendido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "HomePage",
  setup() {
    const router = useRouter();
    const listId = ref("");
    const adminEmail = ref("");
    const isAdminMode = ref(false);
    const showHelp = ref(false);

    const toggleAdminMode = () => {
      isAdminMode.value = !isAdminMode.value;
      adminEmail.value = "";
    };

    const accessList = () => {
      if (listId.value) {
        // Guardar datos de administrador en sessionStorage si aplica
        if (isAdminMode.value && adminEmail.value) {
          sessionStorage.setItem(
            "adminAccess",
            JSON.stringify({
              listId: listId.value,
              email: adminEmail.value,
              isAdmin: true,
            }),
          );
        } else {
          // Limpiar sessionStorage si no es admin
          sessionStorage.removeItem("adminAccess");
        }

        // Navegar sin query params
        router.push({
          name: "viewlist",
          params: { id: listId.value },
        });
      }
    };

    return {
      listId,
      adminEmail,
      isAdminMode,
      showHelp,
      toggleAdminMode,
      accessList,
    };
  },
};
</script>

<style scoped>
.center-container {
  min-height: 80vh;
  display: flex;
  align-items: center;
}

code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.9em;
}

.brand-title {
  font-family: "Hachi Maru Pop", cursive !important;
}
@media (max-width: 600px) {
  h1 {
    font-size: 2rem;
  }
}
</style>
